import { __assign, __rest, __spreadArray } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from "react";
import { Avatar, Button, IconButton, Stack, TextField, Typography, } from "@mui/material";
import { EditOutlined, RemoveCircleOutline } from "@mui/icons-material";
import * as yup from "yup";
import uniqBy from "lodash/uniqBy";
import findIndex from "lodash/findIndex";
import { FieldControl, } from "@pangeacyber/react-mui-shared";
import { cleanPhoneNumber, formatPhoneNumber, validatePhoneNumber, } from "../../utils";
var UnControlledSharePhonesField = function (_a) {
    var _b = _a.onValueChange, onValueChange = _b === void 0 ? function () { } : _b, props = __rest(_a, ["onValueChange"]);
    var value = useMemo(function () {
        var value_ = props.value || props.default || [];
        return uniqBy(value_, "email");
    }, [props.value, props.default]);
    var _c = useState(""), emailValue = _c[0], setEmailValue = _c[1];
    var _d = useState(""), phoneValue = _d[0], setPhoneValue = _d[1];
    var _e = useState(undefined), emailError = _e[0], setEmailError = _e[1];
    var _f = useState(undefined), phoneError = _f[0], setPhoneError = _f[1];
    var _g = useState(undefined), editRow = _g[0], setEditRow = _g[1];
    var minHeight = !(value === null || value === void 0 ? void 0 : value.length)
        ? "0"
        : value.length >= 3
            ? "148px"
            : "".concat(value.length * 48, "px");
    var validatePhone = function () {
        yup
            .string()
            .test("validate-phone", "Must be a valid phone number", validatePhoneNumber)
            .required("Phone number is field")
            .isValid(phoneValue)
            .then(function (isValid) {
            if (!isValid)
                setPhoneError("Must be a valid phone number");
            else
                setPhoneError(undefined);
        });
    };
    var validateEmail = function () {
        yup
            .string()
            .email("Must be a valid email")
            .required("Email is required")
            .isValid(emailValue)
            .then(function (isValid) {
            if (!isValid)
                setEmailError("Must be a valid email");
            else
                setEmailError(undefined);
        });
    };
    useEffect(function () {
        if (phoneValue === "" && emailValue === "") {
            setEmailError(undefined);
            setPhoneError(undefined);
            setEditRow(undefined);
            return;
        }
        if (!!phoneValue) {
            validatePhone();
        }
        if (!!emailValue) {
            validateEmail();
        }
    }, [emailValue, phoneValue]);
    var handleAddOption = function () {
        if (!emailValue || !phoneValue || !!emailError || !!phoneError)
            return;
        var phoneValue_ = cleanPhoneNumber(phoneValue);
        var value_ = __spreadArray([], value, true);
        if (editRow === undefined) {
            value_.push({
                phone_number: phoneValue_,
                email: emailValue,
            });
        }
        else {
            var update = __assign(__assign({}, value_[editRow]), { phone_number: phoneValue_, email: emailValue });
            value_[editRow] = update;
        }
        value_ = uniqBy(value_, "email");
        onValueChange(value_);
        setPhoneValue("");
        setEmailValue("");
        setEditRow(undefined);
    };
    var handleRemoveOption = function (recipient) {
        var idx = findIndex(value, function (v) { return v.email === recipient.email; });
        if (idx === -1)
            return;
        var value_ = value.slice(0, idx).concat(value.slice(idx + 1));
        onValueChange(value_);
    };
    var handleEditOption = function (phone) {
        var idx = findIndex(value, function (v) { return v.email === phone.email; });
        if (idx === -1)
            return;
        setEditRow(idx);
        setPhoneValue(phone.phone_number);
        setEmailValue(phone.email);
    };
    return (_jsxs(Stack, { gap: 1, width: "100%", children: [_jsxs(Stack, { width: "100%", direction: "row", mt: 1, gap: 0.5, alignItems: "flex-start", children: [_jsx(TextField, { value: emailValue, name: "recipient_email", label: "Email", onChange: function (e) {
                            var value = e.target.value;
                            setEmailValue(value);
                            e.stopPropagation();
                        }, error: !!emailError, helperText: emailError, onKeyDown: function (event) { return event.stopPropagation(); }, autoComplete: "off", fullWidth: true, onBlur: handleAddOption, onKeyUp: function (event) {
                            if (event.key === "Enter") {
                                handleAddOption();
                                event.preventDefault();
                            }
                        }, size: "small", sx: {
                            "& .MuiFormHelperText-sizeSmall": {
                                marginLeft: 1,
                            },
                        } }), _jsx(TextField, { value: phoneValue, name: "recipient_phone", label: "Add phone number", onChange: function (e) {
                            var value = e.target.value;
                            setPhoneValue(value);
                            e.stopPropagation();
                        }, error: !!phoneError, helperText: phoneError, onKeyDown: function (event) { return event.stopPropagation(); }, autoComplete: "off", fullWidth: true, onBlur: handleAddOption, onKeyUp: function (event) {
                            if (event.key === "Enter") {
                                handleAddOption();
                                event.preventDefault();
                            }
                        }, size: "small", InputProps: {
                            startAdornment: (_jsx(Typography, { color: "textSecondary", sx: { paddingRight: 1 }, children: "+1" })),
                        } }), _jsx(Button, { variant: "outlined", title: "Add recipient", onClick: handleAddOption, sx: { minWidth: "100px" }, children: editRow === undefined ? "Add" : "Update" })] }), _jsx(Stack, { direction: "row", alignItems: "flex-start", gap: 1, mb: 1, sx: {
                    flexWrap: "wrap",
                    overflow: "hidden",
                    overflowY: "auto",
                    minHeight: minHeight,
                    maxHeight: "calc(100vh - 600px)",
                }, children: value.map(function (recipient, idx) {
                    return (_jsxs(Stack, { direction: "row", alignItems: "center", justifyContent: "space-between", width: "100%", children: [_jsxs(Stack, { direction: "row", gap: 1, children: [_jsx(Avatar, { children: recipient.email.charAt(0).toLocaleUpperCase() }), _jsxs(Stack, { children: [_jsx(Typography, { variant: "body2", children: recipient.email }), _jsx(Typography, { variant: "body2", color: !recipient.phone_number ? "error" : "textSecondary", children: !recipient.phone_number
                                                    ? "Phone number required"
                                                    : formatPhoneNumber(recipient.phone_number) })] })] }), _jsxs(Stack, { direction: "row", children: [_jsx(IconButton, { onClick: function () { return handleEditOption(recipient); }, children: _jsx(EditOutlined, { fontSize: "small" }) }), _jsx(IconButton, { onClick: function () { return handleRemoveOption(recipient); }, children: _jsx(RemoveCircleOutline, { fontSize: "small" }) })] })] }, "email-".concat(idx, "-").concat(recipient.email)));
                }) })] }));
};
var SharePhonesField = function (props) {
    return (_jsx(FieldControl, __assign({}, props, { children: _jsx(UnControlledSharePhonesField, __assign({}, props)) })));
};
export default SharePhonesField;
